import { Image } from 'react-native'

const images = {
  quizLetters: Image.resolveAssetSource(
    require('./../Images/quizLetters.png'),
  ),
  quizInfo: Image.resolveAssetSource(
    require('./../Images/quizInfo.png'),
  ),
  firstLevel: Image.resolveAssetSource(
    require('./../Images/firstLevel.png'),
  ),
  secondLevel: Image.resolveAssetSource(
    require('./../Images/secondLevel.png'),
  ),
  thirdLevel: Image.resolveAssetSource(
    require('./../Images/thirdLevel.png'),
  ),
  background1: Image.resolveAssetSource(
    require('./../Images/Background1.png'),
  ),
  background2: Image.resolveAssetSource(
    require('./../Images/Background2.png'),
  ),
  background3: Image.resolveAssetSource(
    require('./../Images/Background3.png'),
  ),
  quizRibbon: Image.resolveAssetSource(
    require('./../Images/ribbon.png'),
  ),
  thumbsUp: Image.resolveAssetSource(
    require('./../Images/thumbsUp.png'),
  ),
  thumbsDown: Image.resolveAssetSource(
    require('./../Images/thumbsDown.png'),
  ),
  sadFace: Image.resolveAssetSource(
    require('./../Images/sadFace.png'),
  ),
  starlessIcon: Image.resolveAssetSource(
    require('./../Images/starlessIcon.png'),
  ),
  close: Image.resolveAssetSource(
    require('./../Images/close.png'),
  ),

  //hifi
  lottie_celebrate: require('./../Images/lottieIcons/celebrate.json'),
}

export default images

